'use client';

import styles from './WpPostNavigation.module.scss';

export interface IProps {
    /**
     * Контент
     */
    parsedContent:  string | JSX.Element | JSX.Element[];
}

/**
 * Компонент для отображения навигационного элемента поста
 */
export default function WpPostNavigation({ parsedContent }: IProps) {
    return (
        <div className={styles['post__navigation']}>
            <div className={styles['post__navigation_scroll']}>
                <div className={styles['post__navigation_header']}>Содержание</div>
                <div>
                    {parsedContent}
                </div>
            </div>
        </div>
    );
}
